import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { hasRequiredProfileFields } from '../../constants/profileOptions';
import Profile from '../page/Profile';

// Consent and the native login handshake must finish before profile completion.
const ALLOWED_PATHS = ['/legal-consents', '/flutter-web-login', '/login'];

export default function ProfileCompletionGate({ children }) {
  const { currentUser, userProfile } = useAuth();
  const { pathname } = useLocation();
  if (!currentUser || ALLOWED_PATHS.includes(pathname)) return children;
  if (!userProfile || userProfile.uid !== currentUser.uid) {
    return <Box role="status" sx={{ minHeight: '100dvh', display: 'grid', placeItems: 'center' }}><CircularProgress aria-label="Caricamento del profilo" /></Box>;
  }
  if (!hasRequiredProfileFields(userProfile)) {
    return <Profile key={currentUser.uid} completionRequired />;
  }
  return children;
}
